<template>
  <div id="consultant-grid-app" class="consultant-grid-vueapp">
    <div class="consultant-grid-wrapper">
      <div v-if="emptyOnProd" class="no-cosnultant"></div>
      <div v-else class="consultant-item-container" v-for="(consultant, index) in sortedConsultants" :key="index">
        <grid-button
          :consultant="consultant"
          :customer="customer"
          @customerVerified="customerVerified"
          @endCall="getStatus"
          @showError="errorPopup"
        >
        </grid-button>
      </div>
    </div>
    <div>
      <gateway-error
        v-show="showErrorPopup"
        @hideError="hideErrorPopup"
        :errorType="errorType"
        :redirectionLink="redirectionLink"
        :customer="customer"
        :customerData="customerData"
      >
      </gateway-error>
    </div>
  </div>
</template>

<script>
import GridButton from './components/GridButton'
import GatewayError from './components/GatewayError'
import axios from 'axios'

export default {
  name: 'app',

  computed: {
    emptyOnProd() {
      return this.production && (!this.consultants || !this.consultants.length);
    },
    sortedConsultants() {
      const order = {'available': 1, 'busy': 2, 'away': 3};
      return this.consultants.slice().sort((a, b) => (order[a.availability] || 4) - (order[b.availability] || 4));
    }
  },

  data() {
    return {
      showErrorPopup: false,
      errorType: '',
      redirectionLink: '',
      serverUrl: false,
      consultantStatusEnpoint: '',
      customer: {},
      production: true,
      consultants: []
    };
  },

  mounted() {
    this.serverUrl = window.serverUrl;
    this.consultantStatusEnpoint = this.serverUrl + 'consultants/status';
    this.consultants = window.k24CosultantData;

    if (typeof window.production !== 'undefined') {
      this.production = window.production;
    }

    if (typeof window.locale !== 'undefined') {
      this.$translate.setLang(window.locale);
    }
    if (window.k24CustomerData) {
      this.consultantStatusEnpoint += '?customer_id=' + window.k24CustomerData.id;
      this.customer = window.k24CustomerData;
    } else {
      this.customer = null;
    }
    this.getStatus();

    setInterval(() => {
      this.getStatus();
    }, 5000);
  },

  methods: {
    getStatus() {
      axios.get(this.consultantStatusEnpoint)
        .then(response => {
          response.data.availability.forEach(elem => {
            let obj = this.consultants.find(obj => obj.ClairvoyantId === elem.ClairvoyantId);

            if (obj != null) {
              obj.estimatedTime = elem.QueueStatistics.estimated_waiting_time;
              obj.previousCustomers = elem.QueueStatistics.previous_customers_count;
              obj.customerInQueue = elem.QueueStatistics.customer_in_queue;
              obj.queueBlocked = elem.QueueBlocked;

              if (!elem.Active) {
                obj.availability = 'away';
              } else if (elem.Availability && !obj.forceBusy) {
                obj.availability = 'available';
              } else {
                obj.availability = 'busy';
              }
            }
          });
        })
        .catch(error => {
          console.log(error);
        });
    },

    customerVerified(customerData) {
      this.consultantStatusEnpoint = this.consultantStatusEnpoint + '?customer_id=' + customerData.customer.id;
    },

    errorPopup(data) {
      console.log('Opening error modal');
      this.redirectionLink = data.redirectionLink;
      this.customerData = data.customerData;
      this.errorType = data.errorType;
      this.showErrorPopup = true;
    },

    hideErrorPopup() {
      this.showErrorPopup = false;
    }
  },

  components: {
    'grid-button': GridButton,
    'gateway-error': GatewayError
  }
};
</script>

<style lang="scss">
.consultant-grid-vueapp {
  width: 100%;
}
.consultant-grid-wrapper {
  max-width: 991px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
}
.consultant-item-container {
  max-width: 1236px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
}
.c2c-call .dropdown-toggle {
  height: 40px !important;
  text-align: center;
}
.no-cosnultant {
  font-size: 32px;
  text-align: center;
  background-color: #f9080887;
  color: #ffff;
}
@media (max-width: 668px) {
  .consultant-left-container {
    width: 100%;
  }
  .consultant-info-container {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue